import { Badge } from '@/components/ui/badge';
import type { OptimisationRunSummaryDto } from '@cutlyft/zod-schemas';

type RunStatus = OptimisationRunSummaryDto['runStatus'];

const STATUS_CONFIG: Record<RunStatus, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline'; pulse: boolean }> = {
  QUEUED: { label: 'Queued', variant: 'secondary', pulse: true },
  RUNNING: { label: 'Running', variant: 'default', pulse: true },
  COMPLETED: { label: 'Completed', variant: 'outline', pulse: false },
  FAILED: { label: 'Failed', variant: 'destructive', pulse: false },
};

interface RunStatusBadgeProps {
  status: RunStatus;
}

export function RunStatusBadge({ status }: RunStatusBadgeProps) {
  const { label, variant, pulse } = STATUS_CONFIG[status];
  return (
    <Badge variant={variant} className={pulse ? 'animate-pulse' : undefined}>
      {label}
    </Badge>
  );
}
